import { requestPayment } from 'Cloud/Application/Payment';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { renderBizMigrationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { getAbFreeUserSpaceLink, getFeatureMarketingPromoFastcheckout } from 'reactApp/modules/features/features.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { TSendAnalytics } from 'reactApp/ui/Space/SingleSpace/SingleMenu.analytics';
import { TGoToSubs } from 'reactApp/ui/Space/Space.types';

type TUseCallbacks = (props: {
    isMobile: boolean;
    countdownTariff?: string;
    goToSubscriptions: TGoToSubs;
    sendAnalytics: TSendAnalytics;
    isMarketingPromo?: boolean;
}) => {
    onPayment: () => void;
};

export const useCallbacks: TUseCallbacks = ({ isMobile, countdownTariff, goToSubscriptions, sendAnalytics, isMarketingPromo }) => {
    const isOldBizUser = useSelector(UserSelectors.isOldBizUser);
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isAlmostFull = useSelector(UserQuotaSelectors.isAlmostFull);
    const isFull = useSelector(UserQuotaSelectors.isFull);
    const showFastCheckout = useSelector(getFeatureMarketingPromoFastcheckout);

    // tempexp_15071-next-line
    const abFreeUserSpaceLink = useSelector(getAbFreeUserSpaceLink);

    const onPayment = useCallback(() => {
        if (isOldBizUser) {
            renderBizMigrationDialog();
            return;
        }

        sendAnalytics('click');

        if (isMobile) {
            goToSubscriptions();
            return;
        }

        if (isPaidUser && !(isAlmostFull || isFull)) {
            goToSubscriptions();
            return;
        }

        const paymentOptions: { tariff?: string; goToSubscriptions?: TGoToSubs } = {
            goToSubscriptions,
        };

        if (countdownTariff) {
            paymentOptions.tariff = countdownTariff;
        }

        // tempexp_15071-start
        if (abFreeUserSpaceLink && !countdownTariff) {
            goToSubscriptions({ isNewTariffsPage: true });
            return;
        }
        // tempexp_15071-end

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        requestPayment({ ...paymentOptions, forceFastCheckout: isMarketingPromo && showFastCheckout });
    }, [isOldBizUser, sendAnalytics, isMobile, isPaidUser, isAlmostFull, isFull, goToSubscriptions, countdownTariff, abFreeUserSpaceLink]);

    return { onPayment };
};
